import React,{useState, useEffect} from 'react';
import {motion} from 'framer-motion';
import './productsAddCard.css'
import ShopingCard from '../shopingCard';

const ProductsAddCard =({shoppingCart, remoreProductShoppingCard, TIENDA})=>{

    // console.log('--prpduct detail---')
    // console.log(shoppingCart)
    // console.log('--prpduct detail---')

    const [precioTotal, setPrecioTotal] = useState(0);

     useEffect(() => {
        
        var result=0;
        if(shoppingCart.length>0){
            shoppingCart.map(product=>result=result + (product.priceCurrent));
            setPrecioTotal(result)
        }
        
    }, [shoppingCart]); 
    if(shoppingCart.length>0)
    return (
       
        <motion.div initial={{x:-30}} animate={{x:0}} id="content-productcardAdd" className=" fixed sm:top-0 sm:right-0 w-full sm:w-24 sm:h-full opacity-50 hover:opacity-100 bg-gray-600  px-1">

            <div className="block h-16"></div>
            <div className="text-xs text-center pb-1 text-white font-semibold pt-2">
                PRODUCTOS AGREGADOS
            </div>
            <div className="flex flex-row sm:grid sm:grid-cols-1 gap-1  pb-0 pb-20">

            { 
                ShopingCard.length!=0?
                shoppingCart.map((d,i)=>{
        
                    return(
                        <motion.div initial={{scale:0}} animate={{scale:1}}   key={d+i} className="flex flex-col relative rounded-lg bg-white w-full h-28 mx-auto">
                            <div className="rounded-lg bg-white bg-opacity-75 w-full h-20 sm:h-52">
                                <motion.img key={i} initial={{opacity:0}} animate={{opacity:1}} src={d.fotoProducto} className="rounded-lg w-auto h-20 m-auto" alt="" />
                                <div className="top-0 rounded-xl left-0 absolute text-indigo-500 bg-gray-200">{i+1}</div>
                            </div>
                            <div  className="mx-auto">
                                {/* <div className="text-base font-bold text-gray-500 text-left leading-tight py-2">{cardBody.title.substr(0,35)}</div> */}
                                <div className="flex flex-row"> 
                                    <div className="text-sm font-bold text-gray-900">{TIENDA?.country?.currenciesMoneda} {d.priceCurrent}</div>
                                    <div className=" pl-2">
                                        <svg onClick={()=>remoreProductShoppingCard({item:i})} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 hover:text-red-500 cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                </div>
                           
        
                            </div>
                        </motion.div>
                    )
                })
                :''
            }
            <div className="container text-white text-xs font-semibold pt-4">TOTAL: {precioTotal}</div>
            </div>
            
            <div className="hidden sm:block pb-12" />
        </motion.div>
    )
    else return ''
}

export default ProductsAddCard;